import { runtimeConfig } from '../config/runtime';

/**
 * Where the backend services live.
 *
 * Its own module because the Connect transport, the plain-fetch calls (login,
 * health, basemap) and the assistant all need these, and having the transport
 * own them made the session module import the transport that imports the
 * session module.
 *
 * All three come from /config.js at run time (see config/runtime.ts), so one
 * build is promoted through every environment. The TP_WEB_* build variables
 * are the fallback, which is what local development uses.
 *
 * There are three rather than one because the app is served from a different
 * address than the backend in a deployed environment, and because in local
 * development the API and the assistant are genuinely different ports:
 *
 *   local        TP_WEB_API_URL unset  → API on :8092, assistant proxied by vite
 *   deployed     /config.js sets all three → the load balancer's address
 *
 * Whatever they are set to must be reachable by the VIEWER's browser, never
 * `localhost`, which on somebody else's machine is their machine.
 */

/**
 * The Connect API, and the host serving glyph fonts. Absolute, because the
 * map's font requests are made by MapLibre rather than by our own code and do
 * not resolve against anything of ours.
 */
export const apiOrigin =
  runtimeConfig.apiUrl || import.meta.env.TP_WEB_API_URL || 'http://localhost:8092';

/**
 * Prefix for the plain-REST calls (health, basemap archives).
 *
 * Empty means "wherever this page came from", which is what makes the vite
 * dev proxy work locally: one origin, one port, no CORS. A deployment that
 * serves the app and the API from different addresses must set this.
 */
export const apiBaseUrl = runtimeConfig.apiBaseUrl || import.meta.env.TP_WEB_API_BASE_URL || '';

/**
 * Prefix for the assistant.
 *
 * Empty for the same reason as above — the dev server proxies `/ai` to the
 * Python service on :8010. Deployed, the assistant is not reachable at the
 * web app's address, so this must point at whatever routes `/ai` to it.
 */
export const aiBaseUrl = runtimeConfig.aiUrl || import.meta.env.TP_WEB_AI_URL || '';
